import React from 'react';
import { Icon, Card, Button, Empty, Divider, Popconfirm } from 'antd';
import { DangerousLink, Text3, Text4 } from '../../../styles';
import { PermissionHoc } from '../../HOC';

const TransferPermissableButton = PermissionHoc(Button,"TRANSFERS_INITIATE", { is_component: true, fallbackComponent: null });
const PermissablePopConfirm = PermissionHoc(Popconfirm,"BENEFICIARIES_WRITE", { is_component: true, fallbackComponent: null });

const BeneficiariesInfo = (props) => {
    const renderTitle = (beneficiary) => {
        return (
            <div className="mb-2 d-flex justify-content-between">
                <div>
                    <Icon type={`${beneficiary.beneficiary_type == "bank_account" ? "bank" : "qrcode"}`} />
                    <Text3 className="ml-2 mb-2" strong>{beneficiary.beneficiary_type_display}</Text3>
                </div>
                <div className="d-flex align-items-center justify-content-end">
                    {
                        <>
                            <Button size="small" type="link" onClick={() => props.toggleBeneficiaryModal({...beneficiary, is_edit:true})}>Edit</Button>
                            <Divider className="h-75 m-0" type="vertical" />
                        </>
                    }
                    {
                        beneficiary.is_active ?
                            <>
                                <TransferPermissableButton size="small" type="link" onClick={() => props.toggleTransferWizard(beneficiary)}>Transfer</TransferPermissableButton>
                                <Divider className="h-75 m-0" type="vertical" />
                            </> : null
                    }
                    {
                        beneficiary.is_active ?
                            <PermissablePopConfirm
                                placement="bottomRight"
                                title="Are you sure you want to deactivate this beneficiary account?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => props.updateStatus(beneficiary, false)}
                            >
                                <DangerousLink size="small" type="link">Deactivate</DangerousLink>
                            </PermissablePopConfirm>
                            :
                            <PermissablePopConfirm
                                placement="bottomRight"
                                title="Are you sure you want to activate this beneficiary account?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => props.updateStatus(beneficiary, true)}
                            >
                                <Button size="small" type="link">Activate</Button>
                            </PermissablePopConfirm>
                    }
                </div>
                {/* {props.is_submerchant ? 
                    <div className="d-flex align-items-center justify-content-end">
                        {
                            beneficiary.is_active ?
                                <>
                                    <TransferPermissableButton size="small" type="link" onClick={() => props.toggleTransferWizard(beneficiary)}>Transfer</TransferPermissableButton>
                                    <Divider className="h-75 m-0" type="vertical" />
                                </> : null
                        }
                        {
                            beneficiary.is_active  ?
                                <PermissablePopConfirm
                                    placement="bottomRight"
                                    title="Are you sure you want to deactivate this beneficiary account?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => props.updateStatus(beneficiary, false)}
                                >
                                    <DangerousLink size="small" type="link">Deactivate</DangerousLink>
                                </PermissablePopConfirm>
                                :
                                <PermissablePopConfirm
                                    placement="bottomRight"
                                    title="Are you sure you want to activate this beneficiary account?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => props.updateStatus(beneficiary, true)}
                                >
                                    <Button size="small" type="link" >Activate</Button>
                                </PermissablePopConfirm>
                        }
                    </div>
                : null} */}
            </div>
        )
    }

    const renderBeneficiaryName = (beneficiary) => {
        return (
            <div className="row">
                <div className="col-5">
                    <Text4 type="secondary" strong>Beneficiary Name:</Text4>
                </div>
                <div className="col-7">
                    <Text4>{beneficiary.account_name}</Text4>
                </div>
            </div>
        )
    }

    const renderBankDetails = (beneficiary) => {
        return (
            <div>
                <div className="row">
                    <div className="col-5">
                        <Text4 type="secondary" strong>Account Number:</Text4>
                    </div>
                    <div className="col-7">
                        <Text4>{beneficiary.account_number}</Text4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-5">
                        <Text4 type="secondary" strong>IFSC Code:</Text4>
                    </div>
                    <div className="col-7">
                        <Text4>{beneficiary.account_ifsc}</Text4>
                    </div>
                </div>
            </div>
        )
    };

    const renderUpiDetails = (beneficiary) => {
        return (
            <div className="row">
                <div className="col-5">
                    <Text4 type="secondary" strong>UPI VPA:</Text4>
                </div>
                <div className="col-7">
                    <Text4>{beneficiary.upi_handle}</Text4>
                </div>
            </div>
        )
    }

    const renderBeneficiaries = (beneficiaries) => {
        return beneficiaries.map(beneficiary => (
            <Card
                className={`mb-2 ${!beneficiary.is_active ? "bg-transparent" : ""}`}
                size="small"
                title={false}
            >
                {renderTitle(beneficiary)}
                {renderBeneficiaryName(beneficiary)}
                {beneficiary.beneficiary_type == "bank_account" ? renderBankDetails(beneficiary) : renderUpiDetails(beneficiary)}
            </Card>
        ));
    };

    return (
        <div className="beneficiary-info-wrapper">
            {
                !props.beneficiaries.length ?
                    <Empty
                        description={
                            <Text3 className="mb-1" type="secondary">No beneficiaries for this contact.</Text3>
                        }
                    />
                    :
                    renderBeneficiaries(props.beneficiaries)
            }
        </div>
    )
};

export { BeneficiariesInfo };